import type { BeelyEntryType } from "@/src/utils/beely/queryParams";

import { atomWithStorage, createJSONStorage } from "jotai/utils";

export interface BeelyAttribution {
  source: "beely" | null;
  /**
   * From landing URL (`getBeelyEntryType`). Null if user never hit Beely params
   * this session or attribution was cleared before URL data was captured.
   */
  entryType: BeelyEntryType | null;
}

/**
 * Atom to store Beely attribution data.
 * Scoped to the current tab/session via sessionStorage — clears automatically
 * when the tab or browser session ends.
 */
const storage = createJSONStorage<BeelyAttribution>(() =>
  typeof globalThis.window === "undefined"
    ? (undefined as never)
    : globalThis.window.sessionStorage
);

export const beelyAttributionAtom = atomWithStorage<BeelyAttribution>(
  "beelyAttributionAtom",
  {
    source: null,
    entryType: null
  },
  storage,
  { getOnInit: true }
);
